function orderCounter() {

    function getHtml() {
        return `<div class="order_countdown"><p>Best-seller | Reserve your order<br></p>
            <span></span>
        </div>`;
    }

    function removeElements() {
        const elements = document.querySelectorAll(".order_countdown span");

        Array.from(elements).forEach(function(el) {
            el.remove();
        });
    }

    function formatTime(seconds) {
        let minutes = Math.floor(seconds / 60);
        let remainingSeconds = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    }

    const button = document.querySelector('.Avada-Offer__ButtonAddToCart')
    button.insertAdjacentHTML("afterend", getHtml());

    let endTime = localStorage.getItem('orderCountdownEndTime');
    let now = new Date().getTime();
    let countdownFor = 1500; //15 minutes

    // If no saved end time or countdown is finished, set the new end time
    if (!endTime || now >= endTime) {
        endTime = now + 10 * 60 * countdownFor; // Set to {countdownFor} minutes from now
        localStorage.setItem('orderCountdownEndTime', endTime);
    }

    // Set interval to update the countdown
    countdownInterval = setInterval(() => {
        let remainingTime = Math.floor((endTime - new Date().getTime()) / 1000); // Calculate remaining time in seconds

        if (remainingTime <= 0) {
            localStorage.setItem('orderCountdownFinished', true);
            clearInterval(countdownInterval);
            removeElements();
        } else {
            const elements = document.querySelectorAll(".order_countdown span");

            Array.from(elements).forEach(function(el) {
                el.textContent = formatTime(remainingTime);
            });
        }
    }, 1000);
}

function onElementAppear(selector, callback) {
  const element = document.querySelector(selector);
  if (element) {
    callback(element);
    return; // Already present
  }

  const observer = new MutationObserver(() => {
    const el = document.querySelector(selector);
    if (el) {
      callback(el);
      observer.disconnect(); // Stop observing once found
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Usage
onElementAppear('.Avada-Offer__ButtonAddToCart', (button) => {
  orderCounter();
});


